// Used in workspace-details.component.ts and assignment-overview-page.component.ts

// Angular
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

// RXJS/Store
import * as courseStore from "#core/teacher-classes/store";
import * as loginStore from "#login/store";
import { select, Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

// Services/Types/Helpers
import { LocalStorage } from "#core/services";
import { Asset } from "@carnegie-learning/cure-types";
import { LTI_EDULASTIC_LAUNCH_TYPES } from "@carnegie-learning/data-access-angular-passport";
import {
    PPAssignment as Assignment,
    CompositeTaskAssignment,
    Course,
    PPUser as User,
} from "cli-types";

export interface ReadyCheckDialogData {
    userID: number;
    asset: Asset;
    studentAssignments: Assignment[];
    course: Course;
    assignment: Assignment | CompositeTaskAssignment;
}

@Component({
    selector: "readycheck-report-dialog",
    templateUrl: "./readycheck-report-dialog.component.html",
    styleUrls: ["./readycheck-report-dialog.component.scss"],
    standalone: false
})
export class ReadycheckReportDialogComponent implements OnInit, OnDestroy {
    teacher: User;
    course: Course;
    assignment: Assignment | CompositeTaskAssignment;
    userID: number;
    asset: Asset;
    studentAssignments: Assignment[];
    readyCheckDestination = LTI_EDULASTIC_LAUNCH_TYPES.TEACHER_REPORT;

    private ngUnsubscribe = new Subject();

    constructor(
        private store_login: Store<loginStore.UserState>,
        private store_course: Store<courseStore.CoursesState>,
        public dialogRef: MatDialogRef<ReadycheckReportDialogComponent>,
        private localStorage: LocalStorage,
        @Inject(MAT_DIALOG_DATA) public data: ReadyCheckDialogData
    ) {}

    ngOnInit(): void {
        this.asset = this.data.asset;
        this.userID = this.data.userID;
        this.studentAssignments = this.data.studentAssignments;

        this.assignment = this.data.assignment;
        this.course = this.data.course;

        if (!this.data.course) {
            this.store_course
                .pipe(select(courseStore.getCourseByRoute))
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe((course) => {
                    if (course) {
                        this.course = course;
                    }
                });
        }

        this.store_login
            .pipe(select(loginStore.getUserProfile))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((userProfile) => {
                if (userProfile) {
                    this.teacher = userProfile;
                } else {
                    this.teacher = this.localStorage.get("userProfile");
                }
            });
    }

    onCancel() {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }
}
